export const inputColors = {
  border: 'sandstone.60',
  placeholder: 'sandstone.55',
  inputText: 'sandstone.10',
  helpText: 'sandstone.30',
  icons: 'warmGrey.30',
  disabled: 'sandstone.95',
  focus: 'focusColor',
  error: 'energyRed.45',
  loading: 'seaBlue.80',
  loadingBar: 'seaBlue.60',
  success: 'landGreen.35',
} as const

export const stateIcons = {
  error: 'uiExclamationTriangle',
  loading: 'uiSpinnerThird',
  success: 'uiCheck',
} as const

export const inputStateMapping: Record<string, { variant?: string; iconProps: object }> = {
  error: {
    variant: 'red',
    iconProps: {
      color: inputColors.error,
      name: stateIcons.error,
    },
  },
  loading: {
    variant: 'grey',
    iconProps: {
      animation: 'vui-spin 0.6s linear infinite',
      name: stateIcons.loading,
      pathFill: [inputColors.loading, inputColors.loadingBar],
    },
  },
  // inline style instead of a variant — the public 'green' variant was removed; keep the deprecated
  // `state="success"` behaviour visually unchanged without exposing it as a theme variant
  success: {
    variant: undefined,
    iconProps: {
      color: inputColors.success,
      name: stateIcons.success,
    },
  },
}

export const displayValueOnlyTextSize = {
  sm: 'xs',
  md: 'sm',
  lg: 'md',
  xl: 'lg',
} as const

export const clearIconSize = {
  sm: 'sm',
  md: 'sm',
  lg: 'sm',
  xl: 'md',
} as const

export const helpTextSize = {
  sm: 'sm',
  md: 'sm',
  lg: 'md',
  xl: 'md',
} as const

export const helpTextMargin = '60px' as const
